"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailAmp = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var Detail_1 = require("@/pages/detail/components/Detail");
var react_amphtml_1 = require("react-amphtml");
var DetailGalleryState_1 = require("@/pages/detail/states/DetailGalleryState");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var ResultPageState_1 = require("@/pages/search/states/ResultPageState");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
exports.detailAmp = function (props) {
    var renderAmpImg = function (it, i) { return it.src ? (React.createElement(react_amphtml_1.AmpImg, { key: i, specName: "default", className: "cover", src: it.src, width: "800", height: "469", layout: "responsive" })) : null; };
    var renderListingType = function (props) {
        if (props.property.type === SfilterTypeGroup_1.SfilterType.RENT) {
            return props.t.forRent;
        }
        if (props.property.type === SfilterTypeGroup_1.SfilterType.BUY) {
            return props.t.forSale;
        }
        return props.t.forSaleRent;
    };
    var renderPrice = function (props) {
        var currencyCode = props.currencyCode;
        var salePrice = props.property.salePrice;
        var salePriceStrShort = format_1.default.currency(salePrice, currencyCode + " ");
        var leasePrice = props.property.leasePrice;
        var leasePriceStrShort = format_1.default.currency(leasePrice, currencyCode + " ");
        var renderManagementFee = function () {
            if (props.property.includeManagementFee ===
                ResultPageState_1.ResultIncludeManagementFee.EXCLUDE) {
                return (React.createElement("div", { style: { fontSize: '8pt' } }, props.t.excludeManagementFee));
            }
            if (props.property.includeManagementFee ===
                ResultPageState_1.ResultIncludeManagementFee.INCLUDE) {
                return (React.createElement("div", { style: { fontSize: '8pt' } }, props.t.includeManagementFee));
            }
            return null;
        };
        var renderLease = function () {
            if (props.property.isLeaseSubjectToOffer) {
                return props.t.subjectToOffer;
            }
            if (!leasePrice)
                return null;
            return (React.createElement(React.Fragment, null,
                leasePriceStrShort,
                renderManagementFee()));
        };
        var renderSale = function () {
            if (props.property.isSaleSubjectToOffer) {
                return props.t.subjectToOffer;
            }
            if (!salePrice)
                return null;
            return salePriceStrShort;
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null, renderSale()),
            React.createElement("div", null, renderLease())));
    };
    var renderPpsf = function (props) {
        if (props.property.isSubjectToOffer)
            return null;
        var isSaleSa = props.property.salePricePerSqftSaleable ? true : false;
        var isLeaseSa = props.property.leasePricePerSqftSaleable ? true : false;
        var salePpsf = props.property.salePricePerSqftSaleable
            ? props.property.salePricePerSqftSaleable
            : props.property.salePricePerSqftGross;
        var leasePpsf = props.property.leasePricePerSqftSaleable
            ? props.property.leasePricePerSqftSaleable
            : props.property.leasePricePerSqftGross;
        if (salePpsf && leasePpsf) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    "@ ",
                    format_1.default.currency(salePpsf),
                    " / ",
                    props.t.sqft,
                    " (",
                    isSaleSa ? props.t.sa : props.t.gfa,
                    ")"),
                React.createElement("div", null,
                    "@ ",
                    format_1.default.currency(leasePpsf),
                    " / ",
                    props.t.sqft,
                    " (",
                    isLeaseSa ? props.t.sa : props.t.gfa,
                    ")")));
        }
        if (salePpsf) {
            return (React.createElement(React.Fragment, null,
                "@ ",
                format_1.default.currency(salePpsf),
                " / ",
                props.t.sqft,
                " (",
                isSaleSa ? props.t.sa : props.t.gfa,
                ")"));
        }
        return (React.createElement(React.Fragment, null,
            "@ ",
            format_1.default.currency(leasePpsf),
            " / ",
            props.t.sqft,
            " (",
            isLeaseSa ? props.t.sa : props.t.gfa,
            ")"));
    };
    var renderFeature = function (amenity, i) {
        if (amenity.value <= 0)
            return;
        var valueStr = amenity.value > 1
            ? amenity.value + " " + amenity.displayKey
            : "" + amenity.displayKey;
        return (React.createElement("div", { className: "ft-it", key: i }, valueStr));
    };
    var renderSimilarItemWithType = function (it, i, type, currencyCode) {
        var renderPrice = function (item, prefix) {
            var price = type === SfilterTypeGroup_1.SfilterType.BUY ? item.salePrice : item.leasePrice;
            if (price <= 0 || item.isSubjectToOffer) {
                return props.t.subjectToOffer;
            }
            return format_1.default.currency(price, prefix + " ");
        };
        var renderSize = function (item) {
            var netsize = item.sizeSaleable;
            var grosssize = item.sizeGross;
            var size = netsize || grosssize;
            return format_1.default.comma(size);
        };
        var bedFields = it.amenities.filter(function (it2) { return it2.key === 'bed'; });
        var bathFields = it.amenities.filter(function (it2) { return it2.key === 'bath'; });
        var beds = bedFields.length ? bedFields[0].value : -1;
        var baths = bathFields.length ? bathFields[0].value : -1;
        var href = propertyToUrl_1.propertyToUrl(props.langCode, it.building, it.referenceId, it.type);
        return (React.createElement("div", { className: "s-it", key: i },
            React.createElement("a", { href: href, className: "s-image" },
                React.createElement(react_amphtml_1.AmpImg, { specName: "default", width: "175", height: "131", layout: "responsive", src: it.images.length ? it.images[0].path : "" })),
            React.createElement("div", { className: "s-body" },
                React.createElement("a", { href: href, className: "s-name" }, it.building),
                React.createElement("div", { className: "s-price" }, renderPrice(it, currencyCode)),
                React.createElement("div", { className: "s-cs" },
                    React.createElement("div", { className: "s-c" },
                        React.createElement("span", { className: "s-c-value" }, renderSize(it)),
                        React.createElement("span", { className: "s-c-label" },
                            props.t.sqft,
                            "(",
                            it.sizeSaleable ? props.t.sa : props.t.gfa,
                            ")")),
                    React.createElement("div", { className: "s-c" },
                        React.createElement("span", { className: "s-c-value" }, beds),
                        React.createElement("span", { className: "s-c-label" }, props.t.beds)),
                    React.createElement("div", { className: "s-c" },
                        React.createElement("span", { className: "s-c-value" }, baths),
                        React.createElement("span", { className: "s-c-label" }, props.t.baths))))));
    };
    var gtmAttrs = {
        'data-credentials': 'include',
    };
    var gtm = "https://www.googletagmanager.com/amp.json?id=" + props.gtmId + "&gtm.url=SOURCE_URL";
    var renderFeatures = function (props) {
        var amenities = props.property.amenities.filter(function (it) { return it.key !== 'bed' && it.key !== 'bath'; });
        if (!amenities || !amenities.length)
            return null;
        var features = props.property.amenities.filter(function (it) { return it.key !== 'bed' && it.key !== 'bat;h'; });
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "s-head" }, props.t.features),
            React.createElement("div", { className: "ft-list" }, features.map(renderFeature))));
    };
    var renderSimilarItem = function (it, i) {
        return renderSimilarItemWithType(it, i, props.similar.filterType, props.similar.currencyCode);
    };
    var similars = props.similar.results.slice(0, 5);
    var license = props.agent.license;
    var images = props.gallery.items.filter(function (it) { return it.type === DetailGalleryState_1.DetailGalleryItemType.IMAGE; }).filter(function (it) { return it.src; });
    var date = format_1.default.dateFormat(format_1.default.dateStringToDate(props.property.lastUpdated.toString()));
    return (React.createElement(React.Fragment, null,
        props.gtmId ? React.createElement(react_amphtml_1.AmpAnalytics, __assign({}, gtmAttrs, { config: gtm })) : null,
        React.createElement("div", { className: "ct" },
            React.createElement("div", { className: "nav-bar" },
                React.createElement(react_amphtml_1.Button, { on: "tap:menu", className: "nav-menu", specName: "default", id: "menubutton" },
                    React.createElement("span", { className: "fal fa-bars" }))),
            React.createElement(react_amphtml_1.AmpCarousel, { specName: "AMP-CAROUSEL [type=slides]", loop: true, lightbox: true, width: "375", height: "243", layout: "responsive", type: "slides" }, images.map(renderAmpImg)),
            React.createElement("div", { className: "if-wrap" },
                React.createElement("div", { className: "if-main" },
                    React.createElement("h1", { className: "if-name" }, props.property.building),
                    React.createElement("div", { className: "if-type" }, renderListingType(props)),
                    React.createElement("div", { className: "if-id" },
                        props.t.id,
                        ": ",
                        props.property.referenceId),
                    React.createElement("div", { className: "if-address" },
                        React.createElement("span", { className: "fal fa-map" }),
                        " ",
                        props.property.address),
                    React.createElement("div", { className: "if-date" },
                        React.createElement("span", { className: "fal fa-clock" }),
                        date)),
                React.createElement("div", { className: "if-side" },
                    React.createElement("div", { className: "if-price" }, renderPrice(props)),
                    React.createElement("div", { className: "if-ppsf" }, renderPpsf(props)))),
            React.createElement("div", { className: "if-c" },
                React.createElement("div", { className: "if-c-it" },
                    React.createElement("div", { className: "if-c-value" }, Detail_1.renderSize(props)),
                    React.createElement("div", { className: "if-c-label" },
                        props.t.sqft,
                        " (",
                        Detail_1.renderSizeSaGfa(props),
                        ")")),
                React.createElement("div", { className: "if-c-it" },
                    React.createElement("div", { className: "if-c-value" }, Detail_1.renderBeds(props)),
                    React.createElement("div", { className: "if-c-label" }, props.t.beds)),
                React.createElement("div", { className: "if-c-it" },
                    React.createElement("div", { className: "if-c-value" }, Detail_1.renderBaths(props)),
                    React.createElement("div", { className: "if-c-label" }, props.t.baths))),
            React.createElement("div", { className: "if-ds" }, props.property.description),
            renderFeatures(props),
            React.createElement("div", { className: "s-head" }, props.t.contactAgent),
            React.createElement("div", { className: "ct-wrap" },
                props.agent.image ? (React.createElement("div", { className: "ct-image" },
                    React.createElement(react_amphtml_1.AmpImg, { specName: "default", width: "60", height: "60", src: props.agent.image }))) : null,
                React.createElement("div", { className: "ct-info" },
                    React.createElement("div", { className: "ct-name" }, props.agent.name),
                    license ? React.createElement("div", { className: "ct-id" }, license) : null,
                    React.createElement("div", { className: "ct-title" }, props.agent.title),
                    React.createElement("div", { className: "ct-action" },
                        React.createElement("a", { href: "/" + props.langCode + "/communication/enquiry", className: "ct-btn", target: "_blank" },
                            React.createElement("span", { className: "fal fa-envelope" }),
                            " ",
                            props.t.message)))),
            React.createElement("div", { className: "s-head" }, props.t.similarProperties),
            React.createElement(react_amphtml_1.AmpCarousel, { specName: "AMP-CAROUSEL [type=carousel]", className: "s-its", height: "220", layout: "fixed-height", type: "carousel" }, similars.map(renderSimilarItem)),
            React.createElement("div", { className: "ft" }, props.dfoot.nameFootCopyright))));
};
exports.default = react_redux_1.connect(Detail_1.DetailMapStateToProps, function () { return ({}); })(exports.detailAmp);
